
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[region]/[language]/events/special-events/[event]",
      function () {
        return require("private-next-pages/[region]/[language]/events/special-events/[event]/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[region]/[language]/events/special-events/[event]"])
      });
    }
  